/** When a JWT stops working, in milliseconds since 1970, or null if it cannot be read. */
export function tokenExpiresAt(token: string | null | undefined): number | null {
  try {
    const part = (token ?? '').split('.')[1]
    if (!part) return null
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '='))
    const exp = JSON.parse(json).exp
    return typeof exp === 'number' ? exp * 1000 : null
  } catch {
    return null
  }
}

/** Refresh when this little time is left, so people never reach a request that fails. */
export const REFRESH_AHEAD_MS = 5 * 60_000

export const needsRefresh = (token: string | null | undefined, now = Date.now()) => {
  const at = tokenExpiresAt(token)
  return at !== null && at - now < REFRESH_AHEAD_MS
}

/**
 * Where to send someone after they sign in again. Only a page inside our own portals counts: anything else (another
 * site, a script address) is ignored, so a crafted link cannot bounce a person somewhere else.
 */
export function safeNext(raw: string | null | undefined, platform: boolean): string | null {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return null
  const portal = platform ? '/super-admin' : '/tenant'
  return raw === portal || raw.startsWith(`${portal}/`) || raw.startsWith(`${portal}?`) ? raw : null
}
